import React, { useEffect, useState } from "react";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import { useDispatch } from "react-redux";
import { setfeedbackPopup } from "../../redux/features/stylesSlice";
import { wordpressURL } from "../../config";
import TikTokIcon from "../../media/images/twitter-icon.svg";
import { logEvent } from "../../functions/amplitude";
import useIsMobileFooter from "../../functions/isMobileFooter";
import { videos } from "../../constants";

const Footer = ({ setSelectedVideoId }) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobileFooter();

  const handleClick = (event, href, term) => {
    event.preventDefault();
    logEvent(`click_footer_${term}`, { [term]: "clicked" });
    window.open(href, "_blank", "noopener noreferrer");
  };

  return (
    <div className="footer-layout">
      <div className="left">
        <div
          className="feedback"
          onClick={() => {
            dispatch(setfeedbackPopup(true));
            logEvent("click_footer_feedback", { feedback: "clicked" });
          }}
        >
          <ChatBubbleOutlineIcon />
          <p>Feedback</p>
        </div>
        <a
          href={`${wordpressURL}/terms-of-use/`}
          target="_blank"
          rel="noreferrer"
          className="ml-2"
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/terms-of-use/`, "terms");
          }}
        >
          Terms of Use
        </a>
        <a
          href={`${wordpressURL}/privacy/`}
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/privacy/`, "privacy");
          }}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </div>
      <div className="links">
        <div className="flex-col mr-2">
          {videos(isMobile).map((video) => (
            <p
              style={{ cursor: "pointer" }}
              key={video.id}
              onClick={() => {
                setSelectedVideoId(video.id);
              }}
            >
              {video.title}
            </p>
          ))}
        </div>
        <div className="links-icons">
          <a
            href={`${wordpressURL}/faq/`}
            onClick={(e) => {
              handleClick(e, `${wordpressURL}/faq/`, "faq");
            }}
            target="_blank"
            rel="noreferrer"
          >
            FAQ
          </a>

          <a className="icon" href="mailto:contact@sooth.fyi">
            <EmailOutlinedIcon />
          </a>
          <a
            className="icon"
            href={process.env.REACT_APP_TWITTER_URL}
            onClick={(e) =>
              handleClick(e, process.env.REACT_APP_TWITTER_URL, "twitter")
            }
            target="_blank"
            rel="noreferrer"
          >
            <TwitterIcon />
          </a>
          <a
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              window.open(process.env.REACT_APP_FACEBOOK_URL, "_blank");
            }}
            href={process.env.REACT_APP_FACEBOOK_URL}
          >
            <FacebookIcon />
          </a>
          <a
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              window.open(process.env.REACT_APP_LINKEDIN_URL, "_blank");
            }}
            href={process.env.REACT_APP_LINKEDIN_URL}
          >
            <LinkedInIcon />
          </a>
          <a
            className="icon"
            onClick={(e) => {
              e.preventDefault();
              window.open(process.env.REACT_APP_INSTAGRAM_URL, "_blank");
            }}
            href={process.env.REACT_APP_INSTAGRAM_URL}
          >
            <InstagramIcon />
          </a>

          <a
            onClick={(e) => {
              e.preventDefault();
              window.open(process.env.REACT_APP_TIKTOK_URL, "_blank");
            }}
            href={process.env.REACT_APP_TIKTOK_URL}
          >
            <img className="tiktok-icon" src={TikTokIcon} alt="tiktok" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
